import { createContext, useContext } from 'react';
import PocketBase from 'pocketbase';
const pb = new PocketBase(process.env.REACT_APP_API_URL);

const PocketBaseContext = createContext(pb);

export function PocketBaseProvider({ children }) {
  return (
    <PocketBaseContext.Provider value={pb}>
      {children}
    </PocketBaseContext.Provider>
  );
}

export function usePocketBase() {
  return useContext(PocketBaseContext);
}